import { useEffect, useState } from "react";
import { podiumViewMs, restViewMs } from "../constants";

// Wisselt kolom 2 om de zoveel tijd tussen het podium en "Andere verkopers".
// Zijn er niet meer dan drie verkopers, dan valt er niets te wisselen en
// blijft het podium gewoon staan.
export function useRankView(rankCount) {
  const [view, setView] = useState("podium");
  const hasRest = rankCount > 3;

  useEffect(() => {
    if (!hasRest) {
      setView("podium");
      return undefined;
    }
    const timer = setTimeout(
      () => setView(view === "podium" ? "rest" : "podium"),
      view === "podium" ? podiumViewMs : restViewMs,
    );
    return () => clearTimeout(timer);
  }, [hasRest, view]);

  return view;
}
